import { throwError as observableThrowError } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ModaleErroreStore } from "../store/modale-errore.store";
import { env } from "@env/environment";
import { PaginazioneVO } from "../vo/paginazioneVO";
import { OrdinamentoVO } from "../vo/ordinamentoVO";
import { ResultListVO } from "../vo/resultList.vo";
import { FiltroRicercaAttoDTO } from "../dto/filtro-ricerca-attoDTO";
import { ResultListDTO } from "../dto/result-listDTO";

import { MapperNotaLiquidazione } from "../mapper/mapper-nota-liquidazione";
import { NotaLiquidazioneVO } from "../vo/nota-liquidazioneVO";
import { NotaLiquidazioneDTO } from "../dto/nota-liquidazioneDTO";
import { MapperResultListNotaLiquidazione } from "../mapper/mapper-resultList-nota-liquidazione";
import { FiltroRicercaNotaVO } from "../vo/filtro-ricerca-notaVO";
import { MapperFiltroRicercaNota } from "../mapper/mapper-filtro-ricerca-nota";
import { FiltroRicercaNotaDTO } from "../dto/filtro-ricerca-notaDTO";
import { AnagraficaBeneficiarioVO } from "../vo/anagrafica-beneficiarioVO";
import { AnagraficaBeneficiarioDTO } from "../dto/anagrafica-beneficiarioDTO";
import { MapperAnagraficaBeneficiario } from "../mapper/mapper-anagrafica-beneficiario";
import { DocumentoSpesaDTO } from "../dto/documento-spesaDTO";
import { DocumentoSpesaVO } from "../vo/documento-spesaVO";
import { MapperDocumentoSpesa } from "../mapper/mapper-documento-spesa";

import { TipoOperazioneNotaEnum } from "../enum/tipo-operazione-nota-enum";
import { OperazioneSuAttoDTO } from "../dto/operazione-attoDTO";
import { TemplateNotaDTO } from "../dto/template-notaDTO";
import { NotaRequestDTO } from "../dto/nota-requestDTO";
import { DatiPagamentoDTO } from "../dto/dati-pagamentoDTO";
import { RegistraQuietanzeDTO } from "../dto/registra-quietanzeDTO";
import { ContatoreNoteVO } from "../vo/contatore-noteVO";
import { ContatoreNoteDTO } from "../dto/contatore-noteDTO";
import { MapperContatoreNote } from "../mapper/mapper-contatore-note";

@Injectable({
  providedIn: "root",
})
export class NotaLiquidazioneService {
  private urlNota =
    env.DOCUMENTALE_NOTE_API_URL_BASE +
    env.API_DOCUMENTALE_NOTA;

  private urlNotaExt =
    env.DOCUMENTALE_ATTI_API_URL_BASE +
    env.API_DOCUMENTALE_NOTA_EXT;

  constructor(
    private httpClient: HttpClient,
    private modaleErroreStore: ModaleErroreStore,
    private mapperFiltroRicercaNota: MapperFiltroRicercaNota,
    private mapperResultListNotaLiquidazione: MapperResultListNotaLiquidazione,
    private mapperNotaLiquidazione: MapperNotaLiquidazione,
    private mapperAnagraficaBeneficiario: MapperAnagraficaBeneficiario,
    private mapperDocumentoSpesa: MapperDocumentoSpesa,
    private mapperContatoreNote: MapperContatoreNote
  ) { }

  setStatoPagata(id: string): Observable<void> {
    return this.httpClient.get<void>(this.urlNota + id + "/pagata").pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err);
      })
    );
  }

  prendiInCarico(id: string): Observable<NotaLiquidazioneVO> {
    return this.httpClient.put(this.urlNota + id + "/prendiInCarico/", null).pipe(
      map((response: NotaLiquidazioneDTO) =>
        this.mapperNotaLiquidazione.convertDtoToVo(response)
      ),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err);
      })
    );
  }

  rilascia(id: string): Observable<NotaLiquidazioneVO> {
    return this.httpClient.put(this.urlNota + id + "/rilascia/", null).pipe(
      map((response: NotaLiquidazioneDTO) =>
        this.mapperNotaLiquidazione.convertDtoToVo(response)
      ),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err);
      })
    );
  }

  registraQuietanze(payload: RegistraQuietanzeDTO): Observable<void | object> {
    return this.httpClient.post(this.urlNota + "registra-quietanza", payload).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err);
      })
    );
  }

  rimuoviQuietanza(idNota: string, posizione: number): Observable<void> {
    return this.httpClient.delete<void>(this.urlNota + [ idNota, "rimuovi-quietanza", posizione].join("/")).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err);
      })
    );
  }

  recuperaContatoriNote(tipiNota: string[]): Observable<ContatoreNoteVO> {
    return this.httpClient.post(this.urlNota + "contatore", tipiNota).pipe(
      map((response: any) => (response.contatori ? response.contatori : response) as ContatoreNoteVO),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err);
      })
    );
  }

  creaNotaBozza(notaBozza: NotaLiquidazioneDTO): Observable<string> {
    console.log("[NotaLiquidazioneService][creaNotaBozza] url: ", this.urlNota);
    console.log("[NotaLiquidazioneService][creaNotaBozza]  :", notaBozza);

    return this.httpClient
      .post(this.urlNota, notaBozza, { observe: "response" })
      .pipe(
        map((response) => response.headers.get("Location")),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  recuperaNotaById(idNota: string): Observable<NotaLiquidazioneVO> {
    console.log(
      "[NotaLiquidazioneService][recuperaNotaById] url: ",
      this.urlNota
    );

    return this.httpClient.get(this.urlNota + idNota).pipe(
      map((response: NotaLiquidazioneDTO) =>
        this.mapperNotaLiquidazione.convertDtoToVo(response)
      ),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  recuperaListaTemplates(): Observable<TemplateNotaDTO[]> {
    console.log(
      "[NotaLiquidazioneService][recuperaNotaById] url: ",
      this.urlNota
    );

    return this.httpClient.get(this.urlNota + "lista-templates").pipe(
      map((response: TemplateNotaDTO[]) =>
        response
      ),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }






  recuperaTemplateById(idFile: string): Observable<any> {
    console.log(
      "[NotaLiquidazioneService][recuperaNotaById] url: ",
      this.urlNota
    );

    return this.httpClient.get(this.urlNota + "template-file/" + idFile, { responseType: 'text' }).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  modificaNotaBozza(notaBozza: NotaRequestDTO): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log(
      "[NotaLiquidazioneService][modificaNotaBozza] url: ",
      this.urlNota
    );
    console.log(
      "[NotaLiquidazioneService][modificaNotaBozza] notaBozza:",
      notaBozza
    );

    return this.httpClient.put(this.urlNota + notaBozza.id, notaBozza).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }


  caricaDatiPagamento(datiPagamento: DatiPagamentoDTO, idNota: string): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log(
      "[NotaLiquidazioneService][caricaDatiPagamento] url: ",
      this.urlNota
    );
    console.log(
      "[NotaLiquidazioneService][caricaDatiPagamento] idNota:",
      idNota
    );

    return this.httpClient.put(this.urlNota + idNota + "/segnala-pagamento", datiPagamento).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  eliminaNotaBozza(id: string): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log(
      "[NotaLiquidazioneService][eliminaNotaBozza] url: ",
      this.urlNota
    );

    return this.httpClient.delete(this.urlNota + id).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  avanzaNota(
    tipoOperazione: TipoOperazioneNotaEnum,
    idAtto: string,
    data: OperazioneSuAttoDTO
  ): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log("[NotaLiquidazioneService][avanzaNota] url: ", this.urlNota);
    console.log(
      "[NotaLiquidazioneService][avanzaNota] tipoOperazione:",
      tipoOperazione
    );

    return this.httpClient
      .put(
        this.urlNota +
        idAtto +
        "/avanza?operazione=" +
        tipoOperazione.toString(),
        data
      )
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }
  /*
  modificaAttoBozza(attoBozza: AttoRequestDTO): Observable<void | object> {
    // esegue la convesione vo -> dto

    console.log(
      "[NotaLiquidazioneService][modificaAttoBozza] url: ",
      this.urlNota
    );
    console.log(
      "[NotaLiquidazioneService][modificaAttoBozza] creaFascicoloRequestDTO:",
      attoBozza
    );

    return this.httpClient.put(this.urlNota + attoBozza.id, attoBozza).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }


  recuperaAttoById(idAtto: string): Observable<AttoVO> {
    console.log(
      "[NotaLiquidazioneService][recuperaAttoById] url: ",
      this.urlNota
    );

    return this.httpClient.get(this.urlNota + idAtto).pipe(
      map((response: AttoDTO) => this.mapperNota.convertDtoToVo(response)),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  public creaPartenzaBozza(
    creaPartenza: FormCreaCorrispondenzaPartenzaVO,
    idAtto: string
  ): Observable<string> {
    const urlCreaPartenza = this.urlNota + idAtto + "/crea-bozza-partenza";
    return this.httpClient
      .post<string>(
        urlCreaPartenza,
        this.mapperCreaPartenza.convertVoToDto(creaPartenza),
        { observe: "response" }
      )
      .pipe(
        map((response) => response.headers.get("Location")),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  } */

  ricercaAvanzata(
    filtro: FiltroRicercaNotaVO,
    // escludiVisibilita: boolean,
    paginazione: PaginazioneVO,
    ordinamento: OrdinamentoVO
  ): Observable<ResultListVO<NotaLiquidazioneVO>> {
    let url = this.urlNota + env.URL_RICERCA_AVANZATA_NOTA;
    console.log("[NotaLiquidazioneService][ricercaAvanzata] url", url);
    const params = new HttpParams()
      .set("pageElement", paginazione.size.toString())
      .set("pageNumber", paginazione.pageNumber.toString())
      .set("orderBy", ordinamento.elemento.toString())
      .set("direction", ordinamento.direzione.toString());
    console.log("[NotaLiquidazioneService][ricercaAvanzata] params", params);
    const filtroDTO: FiltroRicercaNotaDTO = this.mapperFiltroRicercaNota.convertVoToDto(
      filtro
    );

    return this.httpClient.post(url, filtroDTO, { params: params }).pipe(
      map(
        (resultList: ResultListDTO<NotaLiquidazioneDTO>) =>
          this.mapperResultListNotaLiquidazione.convertDtoToVo(resultList) // creare result list e filtro
      ),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }

  ricercaBeneficiari(
    filtro: AnagraficaBeneficiarioDTO
  ): Observable<AnagraficaBeneficiarioVO[]> {
    console.log("[NotaLiquidazioneService][ricercaBeneficiari]");
    return this.httpClient
      .post(this.urlNotaExt + "/cerca-beneficiari", filtro)
      .pipe(
        map(
          (resultList: AnagraficaBeneficiarioDTO[]) =>
            this.mapperAnagraficaBeneficiario.convertListDtoToVo(resultList) // creare result list e filtro
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  ricercaDocSpesa(filtro: DocumentoSpesaDTO): Observable<DocumentoSpesaVO[]> {
    console.log("[NotaLiquidazioneService][ricercaDocSpesa]");
    return this.httpClient
      .post(this.urlNotaExt + "/cerca-doc-spesa", filtro)
      .pipe(
        map(
          (resultList: DocumentoSpesaDTO[]) =>
            this.mapperDocumentoSpesa.convertListDtoToVo(resultList) // creare result list e filtro
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  /* getElencoVisibilitaById(id: string): Observable<VisibilitaAttoVO[]> {
    console.log("[NotaLiquidazioneService][getElencoVisibilitaById]");
    return this.httpClient
      .get<VisibilitaAttoDTO[]>(this.urlNota + id + "/visibilita")
      .pipe(
        map((response) =>
          this.mapperVisibilitaAtto.convertListDtoToVo(response)
        ),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }

  

  /* PUT: save richiesta to the server */
  /* aggiungiVisibilitaAtto(
    listaVisibilitaAtto: VisibilitaAttoDTO[],
    idAtto: string
  ): Observable<Object> {
    // esegue la convesione vo -> dto

    console.log(
      "[RichiestaService]aggiungiVisibilitaRichiesta: request: ",
      listaVisibilitaAtto,
      ", idRichiesta: ",
      idAtto
    );
    let attoUrl = this.urlNota + idAtto + "/aggiungi-visibilita";

    return this.httpClient.put(attoUrl, listaVisibilitaAtto).pipe(
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  } */
}
